module.exports = __webpack_public_path__ + "img/default-profile-icon.f7b39152.svg";